import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setCreatorOffline  , getCreatorPosts , subCountOfCreator} from "../../service/api";

import { FaSpinner } from "react-icons/fa";

import camera from "../../assets/camera.png";
import gallery from "../../assets/gallery.png";
import TopBar from "./TopBar";

import { HiOutlineEmojiSad } from "react-icons/hi";

function CreatorHome() {
  const [userImage, setUserImage] = useState();
  const [userBanner, setUserBanner] = useState();
  const [username, setUsername] = useState();

  const [isLoading , setIsLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [premiumMemeberCount, setpremiumMemeberCount] = useState(0);
  const [totalPosts, settotalPosts] = useState(0);


  const navigate = useNavigate();

  const getPost = async() =>{
    setIsLoading(true);
    const data = JSON.parse(sessionStorage.getItem("creatordata"));
    const posts = await getCreatorPosts(data.email);
    const premiumMember = await subCountOfCreator(data.email);
    setpremiumMemeberCount(premiumMember);
    settotalPosts(posts.length);
    setPosts(posts);
    setIsLoading(false);

  }
  useEffect(() => {
    const fetchData = async () => {
     
      const data = JSON.parse(sessionStorage.getItem("creatordata"));
      if (!data) navigate("/creator/login");

      setCreatorOffline(data.email);
      setUserImage(data.image);
      setUserBanner(data.banner);
      setUsername(data.name);
      await getPost();
    };
    fetchData();
  }, []);

  return (
    <div className="bg flex flex-col w-screen items-center bg h-full min-h-screen pb-10">
      <TopBar />
      <div className="w-full md:w-1/2">
        <div className="mt-5 ml-5 mr-5 mb-2">
          <div>
            <div
              className={
                "w-full bg-cover bg-no-repeat bg-center h-32 rounded-lg"
              }
              style={{
                backgroundImage:
                  'url("'+userBanner+'")',
              }}
            ></div>
            <div className="p-4 flex w-full">
              <div className="flex flex-col text-center">
                <div className="-mt-20">
                  <div className="rounded-full h-32 w-32">
                    <img
                      className="rounded-full w-full h-full border-4"
                      src={"" + userImage}
                      alt=""
                    />
                  </div>
                  <div className="mt-2 text-slate-100 text-5xl font-semibold">
                    {username}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row flex-wrap align-middle justify-center">
        <div className="mr-10 border-2 border-black py-2 px-2 rounded-2xl">
        Total Posts: {totalPosts}
        </div>
        <div className="ml-10 border-2 border-black p-2 rounded-2xl">
        Followers: {premiumMemeberCount}
        </div>
        </div>
        <div className="flex justify-center  ">
          <div className="flex flex-row mt-4 justify-center items-center gap-8 w-4/5">
            <Link
              to="/creator/live"
              className="flex py-3 px-4 justify-center items-center w-full rounded-2xl bg-white"
            >
              <div className="flex w-1/2 title uppercase text-xl text-center justify-center font-bold">
                GO LIVE
              </div>
              <div className="flex w-1/2 h-24">
                <img src={camera} alt="camera"  />
              </div>
            </Link>
            <Link
              to="/creator/gallery"
              className="flex py-3 px-4 justify-center items-center w-full rounded-2xl bg-white"
            >
              
              <div className="flex w-1/2 title uppercase text-xl text-center justify-center font-bold">
                GALLERY
              </div>
              <div className="flex w-1/2 h-24">
                <img src={gallery} alt="gallery"/>
              </div>
            </Link>
          </div>
        </div>
      </div>
      {
      isLoading ? 
      (
        <center className="py-20 my-20">
          <FaSpinner icon="spinner" className="spinner" size={70} />
        </center>
     
      )
      :
      posts.length > 0 ? (
          <div className="p-5 md:p-10 grid grid-cols-1 md:grid-cols-3 gap-5 xl:grid-cols-4">
            {posts.map((post, index) => (
              <div
                key={index}
                className="flex flex-col relative shadow-md hover:shadow-2xl bg-white rounded-lg transition duration-500 w-56 h-56"
              >
                <img
                  src={`${post.picture}`}
                  alt={post.caption}
                  className="rounded-lg w-full h-full object-cover object-center"
                />
                <div className="px-5 py-1.5 flex items-end bg-black bg-opacity-40 justify-between absolute bottom-0 w-full text-white rounded-b-lg">
                  <h4 className="font-semibold w-3/5 truncate text-white">
                    {post.caption}
                  </h4>
                  <h6 className="flex items-center text-white">₹ {post.fees}</h6>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center h-screen gap-6">
            <div className="flex items-center justify-center">
              <h1 className="font-bold text-9xl text-slate-300">
                <HiOutlineEmojiSad />
              </h1>
            </div>
            <div className="flex flex-col items-center justify-center gap-2.5">
              <h1 className="text-slate-800 text-xl font-semibold">
                No posts yet
              </h1>
              <h3 className="text-slate-300">
                How about posting first picture?{" "}
              </h3>
            </div>
          </div>
        )}


    </div>
  );
}

export default CreatorHome;
